import React from 'react';
import { IconChevronDown } from '@douyinfe/semi-icons';
import { useLocalStorageState } from '../hooks/useLocalStorage';

// 可折叠卡片：点击标题折叠/展开，状态持久化到 localStorage（跨查询、跨会话保留）
const CollapsiblePanel = ({ storageKey, title, sub, extra, className = '', children }) => {
  const [collapsed, setCollapsed] = useLocalStorageState(storageKey, false);

  return (
    <div className={`panel ${className}`}>
      <div className="panel-head" style={collapsed ? { marginBottom: 0 } : undefined}>
        <button
          type="button"
          className="panel-title-toggle"
          onClick={() => setCollapsed(!collapsed)}
          aria-expanded={!collapsed}
          title={collapsed ? '展开' : '折叠'}
        >
          <IconChevronDown size="small" className={`panel-chevron${collapsed ? ' collapsed' : ''}`} />
          <span className="panel-title">
            <span className="panel-title-dot" />
            {title}
            {sub ? (
              <span className="panel-sub" style={{ fontWeight: 400 }}>
                {sub}
              </span>
            ) : null}
          </span>
        </button>
        {!collapsed && extra ? <div className="panel-head-extra">{extra}</div> : null}
      </div>
      {!collapsed && children}
    </div>
  );
};

export default CollapsiblePanel;
